import { createRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { CampusesPage } from "@/components/campuses/campuses-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/campuses",
  validateSearch: (
    search: Record<string, unknown>,
  ): { fromOwner?: string; ownerName?: string; tab?: string } => ({
    fromOwner: typeof search.fromOwner === "string" ? search.fromOwner : undefined,
    ownerName: typeof search.ownerName === "string" ? search.ownerName : undefined,
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  component: CampusesGuard,
});

function CampusesGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  // biome-ignore lint/suspicious/noExplicitAny: route type not yet in TanStack Router's generated types
  const { fromOwner, ownerName, tab } = useSearch({ from: "/_authenticated/campuses" as any }) as {
    fromOwner?: string;
    ownerName?: string;
    tab?: string;
  };

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <CampusesPage fromOwner={fromOwner} ownerName={ownerName} tab={tab} />;
}
